export function isAFunction(func) {
	return func && typeof func === 'function';
}

export function currencyFormat(num){
	return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
 };